<template>
  <div>
    <template v-if="isAllowedToAccessSalesforceDashboard">
      <SalesforceDashboard></SalesforceDashboard>
      <SalesforceShopRequests></SalesforceShopRequests>
    </template>
    <internet-shop-table></internet-shop-table>
    <phone-shop-table></phone-shop-table>
    <group-shop class="mt-5" />
  </div>
</template>

<script>
import { some as _some } from 'lodash-es';
import GroupShop from '../components/secretshop/GroupShop.vue';
import InternetShopTable from '../components/client-shops/InternetShopTable.vue';
import PhoneShopTable from '../components/client-shops/PhoneShopTable.vue';
import SalesforceDashboard from './SalesforceDashboard.vue';
import SalesforceShopRequests from '../components/salesforce/SalesforceShopRequests.vue';

export default {
  name: 'ClientShops',

  components: {
    PhoneShopTable,
    InternetShopTable,
    GroupShop,
    SalesforceDashboard,
    SalesforceShopRequests,
  },

  computed: {
    isSpecificDealerManager() {
      return _some(this.$auth.user().roles, {
        friendly_name: 'Specific Dealer Manager',
      });
    },
    isAllowedToAccessSalesforceDashboard() {
      if (
        window.location.origin.toString().includes('127.0.0.1')
      ) {
        return true;
      }

      return (
        _some(
          this.$auth.user().roles,
          {
            name: 'super-administrator',
          } && window.location.origin.toString().includes('app.webinarinc')
        ) ||
        _some(this.$auth.user().roles, {
          name: 'secret-shopper',
        }) ||
        this.$auth.user().dealer.name === 'TrueCar' ||
        this.$auth.user().dealer_id === 48
      );
    },
  },
};
</script>
